import { render } from "./complaintsSuggestions2.vue?vue&type=template&id=4f53d851&scoped=true"
import script from "./complaintsSuggestions2.vue?vue&type=script&lang=js"
export * from "./complaintsSuggestions2.vue?vue&type=script&lang=js"

import "./complaintsSuggestions2.vue?vue&type=style&index=0&id=4f53d851&scoped=true&lang=css"
import "./complaintsSuggestions2.vue?vue&type=style&index=1&id=4f53d851&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f53d851"]])

export default __exports__